import { render, staticRenderFns } from "./TeamSupervisorForm.vue?vue&type=template&id=55924260&scoped=true&"
import script from "./TeamSupervisorForm.vue?vue&type=script&lang=js&"
export * from "./TeamSupervisorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55924260",
  null
  
)

export default component.exports